import AdminImportTemplateTable from "../../importTemplate/components/AdminImportTemplateTable";

const QuoteImporter = ({addQuoteItems}) => {

    return (
        <>
            <AdminImportTemplateTable user addQuoteItems={addQuoteItems}/>
        </>
    );
}
export default QuoteImporter;